
import {create }from 'zustand';

const useModalStore = create((set) => ({
    isLoginModalOpen: false,
    isSignUpModalOpen: false,
    isForgotPassworModalOpen: false,
    openLoginModal: () => set({ isLoginModalOpen: true, isSignUpModalOpen: false, isForgotPassworModalOpen: false, }),
    closeLoginModal: () => set({ isLoginModalOpen: false }),
    openSignUpModal: () => set({ isSignUpModalOpen: true, isLoginModalOpen: false, isForgotPassworModalOpen: false, }),
    closeSignUpModal: () => set({ isSignUpModalOpen: false }),
    openForgotPassworModal: () => set({ isForgotPassworModalOpen: true, isLoginModalOpen: false, isSignUpModalOpen: false, }),
    closeForgotModal: () => set({ isForgotPassworModalOpen: false }),
    }));

export default useModalStore;
